import { render, staticRenderFns } from "./EnrollmentsCanceled.vue?vue&type=template&id=8eaa0dd2&scoped=true"
import script from "./EnrollmentsCanceled.vue?vue&type=script&lang=js"
export * from "./EnrollmentsCanceled.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentsCanceled.vue?vue&type=style&index=0&id=8eaa0dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eaa0dd2",
  null
  
)

export default component.exports